/* ------------------- Pseudo-React createElement Function ------------------------- */
export function createElement (tag, attrs, children) {
    let element = document.createElement(tag);

    for (let name in attrs) {
        if ( name && attrs.hasOwnProperty(name) ) {
            let value = attrs[name];
            if (value === true) {
                element.setAttribute(name, name);
            } else if (value !== false && value != null) {
                element.setAttribute(name, value.toString());
            }
        }
    }

    for (let i = 2; i < arguments.length; i++) {
        let child = arguments[i];
        element.appendChild(
            child.nodeType == null ?
                document.createTextNode(child.toString()) : child);
    }

    return element;
}

export function createSvgIcon(name, attrs) {
    let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
        use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-'+ name);
    use.setAttribute('href', '#icon-'+ name);
    svg.appendChild(use);

    for (let n in attrs) {
        if ( n && attrs.hasOwnProperty(n) ) {
            let value = attrs[n];
            if (value === true) {
                svg.setAttribute(n, n);
            } else if (value !== false && value != null) {
                svg.setAttribute(n, value.toString());
            }
        }
    }
    return svg;
}

/* ------------------- Smooth scroll into View ------------------------- */
export function scrollToElement( element = null, hash = '', offset = 0) {
    if (!(element instanceof HTMLElement) && hash.length > 2 && hash.indexOf('#') >= 0) {
      element = document.querySelector( hash );
    }
    if ( element && element instanceof HTMLElement ) {
      let y = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({top: y, behavior: 'smooth'});
    } else {
      console.log('Element: %o, Hash: %s', element, hash);
    }
}

export const Utils = (function(){
    return {
       debug: function() {
       },
       createSVGIcon: function(name, attrs) { 
            var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
                use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
            use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-'+ name);
            use.setAttribute('href', '#icon-'+ name);
            svg.appendChild(use);
        
            for (let n in attrs) {
                if ( n && attrs.hasOwnProperty(n) ) {
                    let value = attrs[n];
                    if (value === true) {
                        svg.setAttribute(n, n);
                    } else if (value !== false && value != null) {
                        svg.setAttribute(n, value.toString());
                    }
                }
            }
            return svg;
        },
        createElement: function(tag, attrs, children) {
            var element = document.createElement(tag);
        
            for (let name in attrs) {
                if ( name && attrs.hasOwnProperty(name) ) {
                    let value = attrs[name];
                    if (value === true) {
                        element.setAttribute(name, name);
                    } else if (value !== false && value != null) {
                        element.setAttribute(name, value.toString());
                    }
                }
            }
        
            // console.log(children);
            
            for (let i = 2; i < arguments.length; i++) {
                let child = arguments[i];
                console.log(child);
                element.appendChild( child.nodeType == null 
                    ? document.createTextNode(child.toString())
                    : child
                );
            }
        
            return element;
        },
        scrollToElement: function (element = null, hash = '', offset = 0) {
            if (!(element instanceof HTMLElement) && hash.length > 2 && hash.indexOf('#') >= 0) {
              element = document.querySelector( hash );
            }
            if ( element && element instanceof HTMLElement ) {
              let y = element.getBoundingClientRect().top + window.scrollY - offset;
              window.scrollTo({top: y, behavior: 'smooth'});
            } else {
              console.log('Element: %o, Hash: %s', element, hash);
            }
        }
    }
}());